// src/utils/forms/transformHelper.js

/**
 * ✅ Transform options from {value, label} to {id, name}
 * تحويل البيانات من صيغة الـ API إلى صيغة النموذج
 * 
 * @param {Array} options - [{value, label}]
 * @returns {Array} - [{id, name}]
 */
export const transformOptionsToIdName = (options) => {
    if (!options || !Array.isArray(options)) return [];
    return options.map(option => ({
        id: option.value !== undefined ? option.value : option.id,
        name: option.label !== undefined ? option.label : option.name
    }));
};

/**
 * ✅ Transform pricing units with additional fields
 * 
 * @param {Array} pricingUnits - Pricing units from API
 * @returns {Array} - Transformed pricing units
 */
export const transformPricingUnits = (pricingUnits) => {
    if (!pricingUnits || !Array.isArray(pricingUnits)) return [];
    return pricingUnits.map(unit => ({
        id: unit.value,
        name: unit.label,
        nameAE: unit.name,
        code: unit.code
    }));
};

/**
 * ✅ Transform services to ensure consistent format
 * 
 * @param {Array} services - Services from API
 * @returns {Array} - Transformed services
 */
export const transformServices = (services) => {
    if (!services || !Array.isArray(services)) return [];

    // Check if already in correct format
    if (services[0]?.id && services[0]?.name) {
        return services;
    }

    return services.map(service => ({
        id: service.value || service.id,
        name: service.label || service.name
    }));
};

/**
 * ✅ Extract image URL from various formats
 * 
 * @param {String|Object} image - Image data
 * @returns {String} - Image URL
 */
export const extractImageUrl = (image) => {
    if (!image) return '';
    if (typeof image === 'string') return image;
    return image.file_name || image.url || image.preview || '';
};

/**
 * ✅ Process images array for form
 * 
 * @param {Array} images - Images from API
 * @returns {Array} - Processed images
 */
export const processImages = (images) => {
    if (!images || !Array.isArray(images)) return [];
    return images.map((img) => ({
        id: img.id,
        file_name: img.file_name || img.url || img.preview || '',
        url: img.url || img.preview || '',
        thumbnail: img.thumbnail || '',
        preview: img.preview || img.url || '',
    }));
};
